export abstract class CardStrategyService {
    abstract makeCard(doc);

    getCardProps(doc, params: Record<string, string>): Record<string, string> {
        return {};
    }
}
